import { getAbbreviatedUnit } from 'helpers/unitsAbbreviation';

const getLoadUnitAbbreviation = unit => {
  const normalizedUnit = unit?.toLowerCase() === 'pounds' ? 'lbs' : unit;
  const abbreviation = getAbbreviatedUnit(normalizedUnit);
  return abbreviation === 'lb' ? 'lbs' : abbreviation;
};

export default getLoadUnitAbbreviation;
